export default function AirportsTab(props) {
  const {
    loadingAirports,
    airports,
    visibleAirports,
    search,
    onSearchChange,
    onAirportFocus,
    airportTypeLabels,
    setupComplete
  } = props;

  return (
    <div className="tabContent">
      <div className="sectionTitle">
        <div>
          <h2>Letiště</h2>
          <p>
            {!setupComplete
              ? "Nejdřív založ společnost a vyber startovní stát."
              : loadingAirports
                ? "Načítám letiště..."
                : `${visibleAirports.length} z ${airports.length} letišť připraveno`}
          </p>
        </div>
      </div>

      <input
        value={search}
        onChange={function (event) {
          onSearchChange(event.target.value);
        }}
        placeholder="Hledat letiště, kód nebo zemi"
        disabled={!setupComplete}
      />

      <div className="airportList">
        {visibleAirports.map(function (airport) {
          return (
            <button key={airport.id} onClick={function () { onAirportFocus(airport); }}>
              <strong>{airport.iata || airport.icao || "---"}</strong>
              <span>{airport.name}</span>
              <em>{airportTypeLabels[airport.type] || airport.country || airport.type}</em>
            </button>
          );
        })}
        {!loadingAirports && setupComplete && visibleAirports.length === 0 && <p className="emptyText">Pro aktuální filtr se nenašla žádná letiště.</p>}
      </div>
    </div>
  );
}
